import React, { useState, useEffect } from 'react'
import { Form, Input, Button, message, Progress, Select } from 'antd';
import { config, sendSmsCode, checkSms, sendEmailCode, checkEmailCode, sendWechatCode, checkWechatCode, contactInfo, question,checkQuestion } from './../../service_psw'
import { bind } from 'core-js/fn/function';


// 短信验证码
function Step3_port1(props) {
  const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
  const { prev, next, phone, bindPhone } = props
  const [inp_phone, setinp_phone] = useState()
  // const [showhand, setshowhand] = useState()
  const [intervalue, setintervalue] = useState('')
  const onFinish = (values) => {
    console.log('Success:', values);
    checkSms(values).then(res => {
      if (res.resultCode === 0) {
        message.success('短信验证成功', [0.5])
        next()
      } else {
        message.warning(res.errorMsg, [0.5])
      }
    })
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  useEffect(() => {
    config().then((res) => {
      if (res.resultCode === 0) {
        setintervalue(res.data.smsReInterval)
        // setshowhand(res.data.bindPhone)
      }
    })
  }, [])
  // 倒计时
  let [countDown, setCountDown] = useState(0);

  // 定时器
  let [timer, setTimer] = useState(0);

  // 改变倒计时 countDown 的值
  const handleTimer = () => {
    setCountDown(10);
  };
  // 使用 useEffect 监听 countDown 变化
  useEffect(() => {
    if (countDown > 0) {
      const newTimer = window.setInterval(() => {
        if (countDown < 1) {
          console.log("倒计时结束:", countDown);
          window.clearInterval(newTimer);
        } else {
          setCountDown((countDown -= 1));
        }
      }, 1000);

      setTimer(newTimer);
    }
  }, [countDown]);

  // 组件销毁清除倒计时
  useEffect(() => {
    return () => window.clearInterval(timer);
  }, [timer]);
  const [form] = Form.useForm()
  useEffect(() => {
    if (phone)
      form.setFieldsValue({ phone: phone })
    setinp_phone(phone)
  }, [phone])

  return (
    <>
      {phone || bindPhone ?
        <Form
          form={form}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            name="phone"
            rules={[
              {
                required: true,
                message: '请输入您绑定的手机号',
              },
            ]}
          >
            <Input placeholder='请输入您绑定的手机号' disabled={phone ? true : false} onChange={(e) => {
              setinp_phone(e.target.value)
            }} />
          </Form.Item>
          <Form.Item>

            <Form.Item
              style={{ width: '80%' }}
              name="validCode"
              rules={[
                {
                  required: true,
                  message: '请输入短信验证码',
                },
              ]}

            >
              <Input placeholder='请输入短信验证码' />


            </Form.Item>
            <Form.Item className='send_btn'>
              <Button style={{ height: '32px', margin: '0 0 0 6px' }} type='primary' disabled={countDown} onClick={() => {
                if (phone) {
                  sendSmsCode().then(res => {
                    if (res.resultCode === 0) {
                      setCountDown(intervalue)
                      message.success('发送成功', [0.5])
                    } else {
                      message.warning(res.errorMsg, [0.5])
                    }
                  })
                } else {
                  if (reg.test(inp_phone)) {
                    sendSmsCode(inp_phone).then(res => {
                      if (res.resultCode === 0) {
                        setCountDown(intervalue)
                        message.success('发送成功', [0.5])
                      } else {
                        message.warning(res.errorMsg, [0.5])
                      }
                    })
                  } else {
                    message.warning('手机号格式不正确', [0.5])
                  }

                }
                // if(inp_phone){
                //       sendSmsCode(inp_phone).then(res=>{
                //   if(res.resultCode===0){
                //     setCountDown(intervalue)
                //     message.success('发送成功',[1])
                // }else{
                //     message.warning(res.errorMsg)
                // }
                // })
                // }else{
                //   message.warning('手机号不能为空')
                // }

              }}>{countDown < 1 ? '获取验证码' : countDown}</Button>
            </Form.Item>
          </Form.Item>
          <Form.Item
          >
            <Button style={{ height: '36px', margin: 0, marginRight: 15 }} type="" onClick={prev}>
              上一步
            </Button>
            <Button style={{ height: '36px', margin: 0 }} type="primary" htmlType="submit">
              下一步
            </Button>
          </Form.Item>
        </Form>
        : <div>
          <div style={{ color: '#a30808' }}> 当前用户未绑定手机号，请选择其它方式校验，如果所有方式都无法找回密码，请联系管理员</div>
          <Button style={{ height: '36px', marginTop: '20px', marginRight: 15 }} type="" onClick={prev}>
            上一步
          </Button>
        </div>}
    </>

  )
}

//邮箱
function Step3_port2(props) {
  const { prev, next, email, bindEmail } = props
  // const [showhand, setshowhand] = useState(1)
  const [intervalue, setintervalue] = useState('')
  const [inp_email, setinp_email] = useState()
  const [inp_email2, setinp_email2] = useState()
  var reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;
  const onFinish = (values) => {
    console.log('Success:', values);
    checkEmailCode(values).then(res => {
      if (res.resultCode === 0) {
        message.success('邮箱验证成功', [0.5])
        next()
      } else {
        message.warning(res.errorMsg, [0.5])
      }
    })
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  useEffect(() => {
    config().then((res) => {
      if (res.resultCode === 0) {
        setintervalue(res.data.emailReInterval)
        // setshowhand(res.data.bindEmail)
      }
    })
  }, [])
  // 倒计时
  let [countDown, setCountDown] = useState(0);

  // 定时器
  let [timer, setTimer] = useState(0);

  // 改变倒计时 countDown 的值
  const handleTimer = () => {
    setCountDown(10);
  };
  // 使用 useEffect 监听 countDown 变化
  useEffect(() => {
    if (countDown > 0) {
      const newTimer = window.setInterval(() => {
        if (countDown < 1) {
          console.log("倒计时结束:", countDown);
          window.clearInterval(newTimer);
        } else {
          setCountDown((countDown -= 1));
        }
      }, 1000);

      setTimer(newTimer);
    }
  }, [countDown]);

  // 组件销毁清除倒计时
  useEffect(() => {
    return () => window.clearInterval(timer);
  }, [timer]);

  const [form] = Form.useForm()
  useEffect(() => {
    if (email)
      form.setFieldsValue({ email: email })
    setinp_email(email)
    setinp_email2(true)
  }, [email])
  return (
    <>
      {email || bindEmail ? <Form
        form={form}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: '请输入邮箱地址',
            },
          ]}
        >
          <Input placeholder='请输入您绑定的邮箱地址' disabled={email ? true : false} onChange={(e) => {
            setinp_email(e.target.value)
          }} />
        </Form.Item>
        <Form.Item>

          <Form.Item
            style={{ width: '80%' }}
            name="validCode"
            rules={[
              {
                required: true,
                message: '请输入邮箱验证码',
              },
            ]}

          >
            <Input placeholder='请输入邮箱验证码' />


          </Form.Item>
          <Form.Item
            className='send_btn' >

            <Button disabled={countDown} style={{ height: '32px', margin: '0 0 0 6px' }} type='primary'
              onClick={() => {
                if (email) {
                  sendEmailCode().then(res => {
                    if (res.resultCode === 0) {
                      setCountDown(intervalue)
                      message.success('发送成功', [0.5])
                    } else {
                      message.warning(res.errorMsg, [0.5])
                    }
                  })
                } else {
                  if (reg.test(inp_email)) {
                    sendEmailCode(inp_email).then(res => {
                      if (res.resultCode === 0) {
                        setCountDown(intervalue)
                        message.success('发送成功', [0.5])
                      } else {
                        message.warning(res.errorMsg, [0.5])
                      }
                    })
                  } else {
                    message.warning('邮箱格式不正确', [0.5])
                  }

                }
                // if (!reg.test(inp_email) && !setinp_email2) {
                //   message.warning('请输入正确的邮箱格式')
                // } else {
                //   if (inp_email) {
                //     sendEmailCode(inp_email, inp_email2).then(res => {
                //       if (res.resultCode === 0) {
                //         setCountDown(intervalue)
                //         message.success('发送成功', [1])
                //       } else {
                //         message.warning(res.errorMsg)
                //       }
                //     })
                //   } else {
                //     message.warning('请输入邮箱')
                //   }
                // }
              }
              }>{countDown < 1 ? '获取验证码' : countDown}</Button>
          </Form.Item>
        </Form.Item>
        <Form.Item
        >
          <Button style={{ height: '36px', margin: 0, marginRight: 15 }} type="" htmlType="submit" onClick={prev}>
            上一步
          </Button>
          <Button style={{ height: '36px', margin: 0 }} type="primary" htmlType="submit">
            下一步
          </Button>
        </Form.Item>
      </Form> :
        <div>
          <div style={{ color: '#a30808' }}>当前用户未绑定邮箱，请选择其它方式校验，如果所有方式都无法找回密码，请联系管理员</div>
          <Button style={{ height: '36px', margin: 0, marginTop: 20 }} type="" onClick={prev}>
            上一步
          </Button>
        </div>}
    </>
  )
}

//微信
function Step3_port3(props) {

  const { prev, next } = props
  const [intervalue, setintervalue] = useState('')
  const onFinish = (values) => {
    console.log('Success:', values);
    checkWechatCode(values).then(res => {
      if (res.resultCode === 0) {
        message.success('微信验证成功', [0.5])
        next()
      } else {
        message.warning(res.errorMsg, [0.5])
      }
    })

  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  useEffect(() => {
    config().then((res) => {
      if (res.resultCode === 0) {
        setintervalue(res.data.emailReInterval)
      }
    })
  }, [])
  // 倒计时
  let [countDown, setCountDown] = useState(0);

  // 定时器
  let [timer, setTimer] = useState(0);

  // 改变倒计时 countDown 的值
  const handleTimer = () => {
    setCountDown(10);
  };
  // 使用 useEffect 监听 countDown 变化
  useEffect(() => {
    if (countDown > 0) {
      const newTimer = window.setInterval(() => {
        if (countDown < 1) {
          console.log("倒计时结束:", countDown);
          window.clearInterval(newTimer);
        } else {
          setCountDown((countDown -= 1));
        }
      }, 1000);

      setTimer(newTimer);
    }
  }, [countDown]);

  // 组件销毁清除倒计时
  useEffect(() => {
    return () => window.clearInterval(timer);
  }, [timer]);
  return (
    <Form
      name="basic"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >

      <Form.Item>

        <Form.Item
          style={{ width: '80%' }}
          name="validCode"
          rules={[
            {
              required: true,
              message: '请输入微信验证码',
            },
          ]}

        >
          <Input placeholder='请输入微信验证码' />


        </Form.Item>
        <Form.Item
          className='send_btn' >
          <Button style={{ height: '32px', margin: '0 6px' }} type="primary" disabled={countDown} onClick={() => {
            sendWechatCode().then(res => {
              if (res.resultCode === 0) {
                setCountDown(intervalue)
                message.success('发送成功', [0.5])
              } else {
                message.warning(res.errorMsg, [0.5])
              }
            })
          }}
          >{countDown < 1 ? '获取验证码' : countDown}</Button>
        </Form.Item>
      </Form.Item>
      <Form.Item
      >
        <Button style={{ height: '36px', margin: 0, marginRight: 15 }} type="" htmlType="submit" onClick={prev}>
          上一步
        </Button>
        <Button style={{ height: '36px', margin: 0 }} type="primary" htmlType="submit">
          下一步
        </Button>
      </Form.Item>
    </Form>
  )
}

//密保问题  
function Step3_port4(props) {
  const { prev, next } = props
  const { Option } = Select;
  const [questionlist, setquestion] = useState()
  const [questionlistfilter, setquestionfilter] = useState()
  const [dataquest,setdataquestion] = useState()
  const [selected,setselected] = useState()
  const onFinish = (values) => {
    console.log('Success:', values);
    checkQuestion(values).then(res=>{
      if (res.resultCode === 0) {
        message.success('密保验证成功', [0.5])
        next()
      } else {
        message.warning(res.errorMsg, [0.5])
      }
    })
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  useEffect(() => {
    question().then(res => {
      if (res.resultCode === 0) {
        setquestion(res.data.question)
      }
    })
  }, [])
  useEffect(() => {
    if (questionlist) {
      setquestionfilter(questionlist.filter((item) =>
        item
      ))
    }
  }, [questionlist])
  useEffect(()=>{
    if(questionlistfilter){
     const B=  questionlistfilter.map((item,i) => {
       if(item.selected){
        setselected(item.id)
       }
        return  <Option key={i}  value={item.id}>{item.text}</Option>
      })
      setdataquestion(B)
    }
  
  },[questionlistfilter])

  const [form] = Form.useForm()
  useEffect(() => {
    if (selected)
      console.log('1');
      form.setFieldsValue({ passwordQuestion: selected },{passwordAnwser:1111})
  }, [selected,form])

  return ( 
    <Form form = {form}
      name="basic"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
    <Form.Item
        name="passwordQuestion"
        rules={[
          {
            required: true,
            message: '请输入密保问题',
          },
        ]}
      >
       <Select style={{textAlign:'left'}} placeholder='请输入密保问题' >
       {dataquest}
        </Select>
      </Form.Item>
      <Form.Item
        className='send_btn'
        name="passwordAnwser"
        rules={[
          {
            required: true,
            message: '请输入密保答案',
          },
        ]}>
        <Input placeholder='请输入密保答案' />
      </Form.Item>
      <Form.Item
      >
        <Button style={{ height: '36px', margin: 0, marginRight: 15 }} type="" htmlType="submit" onClick={prev}>
          上一步
        </Button>
        <Button style={{ height: '36px', margin: 0 }} type="primary" htmlType="submit">
          下一步
        </Button>
      </Form.Item>
    </Form>
  )
}

export default function Step3(props) {
  const { next, port, prev } = props
  const [phone, setphone] = useState()
  const [email, setemail] = useState()
  const [bindPhone, setbindPhone] = useState()
  const [bindEmail, setbindEmail] = useState()
  useEffect(() => {
    contactInfo().then(res => {
      console.log(res.data);
      if (res.resultCode === 0) {
        setphone(res.data.phone)
        setemail(res.data.email)
        setbindPhone(res.data.bindPhone)
        setbindEmail(res.data.bindEmail)
      }
    })
  }, [])
  const ports = [<Step3_port1 bindPhone={bindPhone} phone={phone} prev={prev} next={next} />, <Step3_port2 bindEmail={bindEmail} email={email} prev={prev} next={next} />, <Step3_port3 prev={prev} next={next} />, <Step3_port4 prev={prev} next={next} />]

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  return (
    <>
      {ports[port - 1]}
    </>
  )
}